import * as React from "react";
import { FileItem } from "@/types/fse";
import { CornerDownRight, Files, ShieldAlert, Users } from "lucide-react";
import { useLazyGetDocumentGroupsDetailsQuery } from "@/modules/documentGroup/documentGroup.api";
import TopBarProgress from "react-topbar-progress-indicator";
import { Tooltip } from "@/components/ui/tooltip";
import { getRejectionLabel } from "../rejectionUtils";

interface Props {
  item: FileItem;
  isShared?: boolean;
}

export const DriveRowNameDocumentGroup: React.FC<Props> = ({ item, isShared }) => {
  const [showDetails, setShowDetails] = React.useState(false);

  const [getDocumentGroupsDetails, { data: groupsDetails, isLoading }] = useLazyGetDocumentGroupsDetailsQuery();

  const handleMouseOver = () => {
    if (item.type === "file" && item.document_group_id && !groupsDetails) {
      getDocumentGroupsDetails([item.document_group_id]);
    }
  };

  const handleOnClick = () => {
    setShowDetails(!showDetails);
  };

  return (
    <div className="min-w-0">
      <div className="flex min-w-0 cursor-pointer items-center" onClick={handleOnClick} onMouseOver={handleMouseOver}>
        <Files className="mr-2 h-5 w-5 shrink-0 text-indigo-600" />
        <span className="flex min-w-0 flex-1 truncate font-medium" title={item.name}>
          {item.name}
          {isShared && <Users className="ml-2 mt-1 h-3 w-3 text-gray-500" />}
          {item.rejection_reason && (
            <Tooltip
              text={getRejectionLabel(item.rejection_reason)}
              className="rounded bg-black text-xs text-white"
              delayDuration={50}
            >
              <span className="ml-2 flex items-center text-sm text-red-500">
                <ShieldAlert className="mr-1 h-3 w-3" />
                Rejected
              </span>
            </Tooltip>
          )}
        </span>
      </div>
      {showDetails && (
        <>
          {isLoading && <TopBarProgress />}

          {groupsDetails &&
            groupsDetails.map(groupDetails => (
              <div className="p-2" key={groupDetails.parent.id}>
                <div className="mb-1 text-sm text-gray-600">Consists of:</div>
                {groupDetails.items.map(doc => (
                  <div key={doc.id} className="mb-1 ml-2 flex items-center">
                    <CornerDownRight className="mr-2 h-4 w-4 text-gray-600" />
                    <span className="text-sm" title={doc.id}>
                      {doc.name}
                    </span>
                  </div>
                ))}
              </div>
            ))}
        </>
      )}
    </div>
  );
};
